import { Policy } from '@models/policy.model';
import { Service } from '@models/service.model';
import { Step } from '@models/step.model';
import { Trigger } from '@models/trigger.model';
import { Discrepancy } from './discrepancy.model';
import { WolfieKnowledge } from './wolfie.model';

export enum ProcessStatus {
  DRAFT = 'DRAFT',
  DONE = 'DONE',
  LOCKED = 'LOCKED',
}

export interface Process {
  processId: string;
  serviceId: string;
  category: string;
  name: string;
  goal: string;
  order: number;
  status: ProcessStatus;
  lastUpdatedAt?: string;
  currentVersion?: string;
  triggers?: Trigger[];
  steps?: Step[];
  service?: Service;
  policies?: Policy[];
  location?: string;
  triggeredBy?: Step[];
  generatedFrom?: string;
  generatedFromName?: string;
  aiMetadata?: {
    knowledge?: WolfieKnowledge[];
  };
  discrepancies?: Discrepancy[];
}

export interface CategorizedProcess {
  [key: string]: Process[];
}

export interface CategorizedPolicy {
  [key: string]: Policy[];
}

export interface ProcessCategory {
  processCategoryId: string;
  name: string;
}

export interface getProcessesRequest {
  getProcesses: Process[];
}

export interface getProcessWithTriggeredByRequest {
  getProcessWithTriggeredBy: Process;
}

export interface getProcessesWithTriggeredByRequest {
  getProcessesWithTriggeredBy: Process[];
}

export interface getProcessesWithAreaServiceRequest {
  getProcessesWithAreaService: Process[];
}

export interface getProcessByIdRequest {
  getProcessById: Process;
}

export interface getProcessesByServiceIdRequest {
  getProcessesByServiceId: Process[];
}

export interface createOrUpdateProcessRequest {
  createProcess?: Process;
  updateProcess?: Process;
}

export interface reorderProcessesRequest {
  reorderProcesses: {
    messages: string[];
  };
}

export interface updateProcessStatusRequest {
  updateProcessStatus: Process;
}

export interface deleteProcessRequest {
  deleteProcess: {
    affected: number;
  };
}

export interface getProcessesNameByIdRequest {
  getProcessesNameById: {
    name: string;
    processId: string;
  }[];
}

export interface processPolicyLinkRequest {
  linkProcessPolicy: Process;
}

export interface LinkedProcess {
  processId: string;
  name?: string;
  label?: string;
}

export interface ProcessWithLabel extends Process {
  label?: string;
}

export interface getProcessByIdWithDiscrepanciesRequest {
  getProcessByIdWithDiscrepancies: Process;
}

export interface ProcessWithOrganizationContext {
  process: Process;
  organizationId: string;
  organizationName: string;
  userRole: string;
}

export interface findProcessAcrossOrganizationsRequest {
  findProcessAcrossOrganizations: ProcessWithOrganizationContext | null;
}
